/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import InputField from "../../../../components/common/new/InputField/InputField";
import Typography from "../../../../components/common/new/Typography/Typography";
import GohonzonOtherInput from "../../../../components/GohonzonOtherInput/GohonzonOtherInput";
import { GOHONZON_OMAMORI_FIELDS } from "../../../../contants/formFields";
import styles from "../GohonzonSubmission.styles";

function GohonzonOmamoriForm({ values, handleChange, readOnly }) {
  return (
    <Box>
      <Box py="18px">
        <Box
          style={{
            width: "178px",
            height: "44px",
            flexShrink: "0",
            borderRadius: "35px",
            background: "#196AAB",
            marginBottom: "-35px",
            position: "relative",
            zIndex: "1",
            marginLeft: "45px",
          }}
        >
          <Typography
            variant="title3"
            style={{
              color: "#FFF",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "Noto Sans",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "20px",
              padding: "12px 40px 12px 40px",
            }}
          >
            Other Details
          </Typography>
        </Box>
      </Box>
      <Box
        style={{
          borderRadius: "5px 5px 5px 5px",
          border: "1px solid #C2D4EB",
          background: "#F6F6F6",
          padding: "0px 0px 20px 20px",
          borderBottom: "9px solid #196AAB",
          margin: "0px 20px",
        }}
      >
        <Box
          style={{
            ...styles.gridContainerOtherDeatils,
            ...styles.addMemberContainer,
          }}
        >
          <InputField
            name={GOHONZON_OMAMORI_FIELDS.COMPANY_NAME}
            value={values[GOHONZON_OMAMORI_FIELDS.COMPANY_NAME]}
            label="Name of company organisation"
            onChange={handleChange}
            disabled={readOnly}
          />
          <InputField
            onChange={handleChange}
            name={GOHONZON_OMAMORI_FIELDS.JOB_POSITION}
            value={values[GOHONZON_OMAMORI_FIELDS.JOB_POSITION]}
            label="Position in job / Business"
            disabled={readOnly}
          />
          <InputField
            name={GOHONZON_OMAMORI_FIELDS.NATURE_OF_WORK}
            value={values[GOHONZON_OMAMORI_FIELDS.NATURE_OF_WORK]}
            label="Name of work"
            onChange={handleChange}
            disabled={readOnly}
          />
          <InputField
            type="number"
            name={GOHONZON_OMAMORI_FIELDS.DAYS_AWAY_FROM_HOME}
            value={values[GOHONZON_OMAMORI_FIELDS.DAYS_AWAY_FROM_HOME]}
            label="Days away from home for official work in 1 year"
            onChange={handleChange}
            disabled={readOnly}
            InputProps={{ inputProps: { min: 0 } }}
          />
          <InputField
            type="number"
            name={GOHONZON_OMAMORI_FIELDS.REGULAR_PRACTICE}
            value={values[GOHONZON_OMAMORI_FIELDS.REGULAR_PRACTICE]}
            label="Years of active and regular practice"
            onChange={handleChange}
            disabled={readOnly}
            InputProps={{ inputProps: { min: 0 } }}
          />
          <InputField
            type="number"
            name={GOHONZON_OMAMORI_FIELDS.GOHONZON_MEMBERSHIP}
            value={values[GOHONZON_OMAMORI_FIELDS.GOHONZON_MEMBERSHIP]}
            label="Gohonzon Membership (Years)"
            onChange={handleChange}
            disabled={readOnly}
            InputProps={{ inputProps: { min: 0 } }}
          />
        </Box>
        <Box style={styles.gridContainer} my={8}>
          {/* <GohonzonOtherInput
          name={GOHONZON_OMAMORI_FIELDS.COMPANY_NAME}
          preLabel="AWAY FROM HOME FOR WORK FOR MORE THAN 120 DAYS?"
        /> */}
          <GohonzonOtherInput
            value={values[GOHONZON_OMAMORI_FIELDS.ACTIVE_PARTICIPATION]}
            name={GOHONZON_OMAMORI_FIELDS.ACTIVE_PARTICIPATION}
            preLabel="ACTIVE PARTICIPATION IN BSG"
            buttonLabels={["Active", "Not Active"]}
            lableValues={["ACTIVE", "INACTIVE"]}
            handleChange={handleChange}
            readOnly={readOnly}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default GohonzonOmamoriForm;
